export const track = (event, properties = {}) => {
  window.dispatchEvent(new CustomEvent('praytoday:analytics', { detail: { event, properties } }));
  if (window.analytics?.track) window.analytics.track(event, properties);
};
